<div class="raw-content-page-layout">
  <div class="doc-content-wrapper">
    <app-doc-card
        [date]="doc.date"
        [src]="'./assets/docs/' + doc.url"></app-doc-card>
  </div>

  <oth-button
      [buttonClasses]="[
      'lighter-contrast-border-color',
      'lighter-contrast-font-color',
      'transparent-button'
    ]"
      [icon]="'chevron-left'"
      [routerLink]="URLS.docs"
      [text]="'Back'">
  </oth-button>
</div>
